import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_H_C, LL_V_L, ModuleFE_Toaster, TS_Button } from '@nu-art/thunderstorm-frontend/index';
import './EditorHCSv2_Manager.scss';
import { ModuleFE_Referencable } from '../../../../_entity/referencable/index.js';
import { EditorHCSv2_ReferencableEditor } from '../EditorHCSv2_VariableEditor/index.js';
import { Page_ItemsEditor } from '@nu-art/thunderstorm-frontend/components/Page_ItemsEditor/index';
import { TS_EditableItemControllerProto } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemControllerProto/index';
import { sortArray } from '@nu-art/ts-common';
export class Controller extends TS_EditableItemControllerProto {
    static defaultProps = {
        keys: ['selected'],
        module: ModuleFE_Referencable,
        editor: EditorHCSv2_ReferencableEditor,
        createInitialInstance: () => ({ properties: {} })
    };
}
export class EditorHCSv2_Manager extends Page_ItemsEditor {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        if (!state.editable.item.label)
            state.editable.item.label = '';
        if (!state.editable.item.prototypes)
            state.editable.item.prototypes = [];
        if (!state.editable.item.properties)
            state.editable.item.properties = {};
        if (!state.editable.item.type)
            state.editable.item.type = [];
        return state;
    }
    static defaultProps = {
        module: ModuleFE_Referencable,
        keys: Page_ItemsEditor._defaultProps.keys,
        mapper: (referencable) => [referencable.label],
        sort: (referencable) => sortArray(referencable, 'label'),
        itemRenderer: (referencable) => {
            return (_jsx(LL_V_L, { className: "referencable-item", children: _jsx(LL_H_C, { className: "match_height", children: referencable.label }) }));
        },
        EditorRenderer: (props) => _jsx(Controller, { ...props }),
    };
    render() {
        return _jsxs(LL_V_L, { className: "editor-hcs-v2--manager", children: [_jsx(LL_H_C, { children: _jsx(TS_Button, { onClick: async () => {
                            await ModuleFE_Referencable.v2.setup({}).executeSync();
                            ModuleFE_Toaster.toastInfo('Setup completed');
                            this.forceUpdate();
                        }, children: "Setup" }) }), super.render()] });
    }
}
//# sourceMappingURL=EditorHCSv2_Manager.js.map